// import React from 'react';
// import { PieChart, Tooltip, Pie, ResponsiveContainer } from 'recharts';




// const AttendanceChart = ({ allattendanceStatus, height }) => {

//   const data = [
//     // {
//     //   name: "Present",
//     //   uv: allattendanceStatus.present,
//     //   fill: "#18A118",
//     // },
//     {
//       name: "On Time",
//       uv: allattendanceStatus.ontime,
//       fill: "#18A118",
//     },
//     {
//       name: "Late",
//       uv: allattendanceStatus.late,
//       fill: "#F7BA1E",
//     },
//     {
//       name: "Half Day",
//       uv: allattendanceStatus.halfday,
//       fill: "#FF747C",
//     },
//     {
//       name: "Absent",
//       uv: allattendanceStatus.absent,
//       fill: "#FF0000",
//     },
//     // {
//     //   name: "Leave",
//     //   uv: allattendanceStatus.leave,
//     //   fill: "#AC98C7",
//     // },
//     // {
//     //   name: "Out Duty",
//     //   uv: allattendanceStatus.outduty,
//     //   fill: "#30C9C9",
//     // },
//   ];
//   const display = [
//     {
//       name: "Present",
//       uv: allattendanceStatus.present,
//       fill: "#18A118",
//     },
//     {
//       name: "Out Duty",
//       uv: allattendanceStatus.outduty,
//       fill: "#2576BC",
//     },
//     {
//       name: "Leave",
//       uv: allattendanceStatus.leave,
//       fill: "#30C9C9",
//       // fill: "#AC98C7",
//     },

//     {
//       name: "Absent",
//       uv: allattendanceStatus.absent,
//       fill: "#FF0000",
//     },
//   ];

//   return (
//     <ResponsiveContainer className="piechart" height={height} width="90%">
//       <div className="attendancechart-heading">
//         <div className="repo-heading-a font-weight500   font-size-subheading">Behaviour:</div>
//         <div>
//           {data.map((item) => {
//             return (
//               <div key={item.name} className="piechart-legend">
//                 <div
//                   className="piechart-dot"
//                   style={{ backgroundColor: item.fill }}
//                 ></div>
//                 <div className="piechart-subheading  font-weight500    font-size-subheading" style={{ color: item.fill }}>
//                   {item.name} - {item.uv}
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>

//       <PieChart>
//         <Pie
//           data={data}
//           // label={renderCustomizedLabel}
//           outerRadius={140}
//           innerRadius={90}
//           dataKey="uv"
//         ></Pie>
//         {/* <Tooltip /> */}
//       </PieChart>
//       <div className="attendancechart-heading">
//         <div className="repo-heading-a font-weight500   font-size-subheading">Attendance:</div>
//         <div>
//           {display.map((item) => {
//             return (
//               <div key={item.name} className="piechart-legend">
//                 <div
//                   className="piechart-dot"
//                   style={{ backgroundColor: item.fill }}
//                 ></div>
//                 <div className="piechart-subheading  font-weight500    font-size-subheading" style={{ color: item.fill }}>
//                   {item.name} - {item.uv}
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       </div>
//     </ResponsiveContainer>
//   );
// };

// export default AttendanceChart;



// import React from 'react';
// import { PieChart, Pie, ResponsiveContainer, Cell, Tooltip } from 'recharts';

// const AttendanceChart = ({ allattendanceStatus, height }) => {
//   const data = [
//     { name: "On Time", uv: allattendanceStatus.ontime, fill: "#18A118" },
//     { name: "Late", uv: allattendanceStatus.late, fill: "#F7BA1E" },
//     { name: "Half Day", uv: allattendanceStatus.halfday, fill: "#FF747C" },
//     { name: "Absent", uv: allattendanceStatus.absent, fill: "#FF0000" },
//   ];

//   const display = [
//     { name: "Present", uv: allattendanceStatus.present, fill: "#18A118" },
//     { name: "Out Duty", uv: allattendanceStatus.outduty, fill: "#2576BC" },
//     { name: "Leave", uv: allattendanceStatus.leave, fill: "#30C9C9" },
//     { name: "Absent", uv: allattendanceStatus.absent, fill: "#FF0000" },
//   ];

//   // Custom Tooltip for a polished hover effect
//   const CustomTooltip = ({ active, payload }) => {
//     if (active && payload && payload.length) {
//       return (
//         <div style={{
//           backgroundColor: 'rgba(255, 255, 255, 0.95)',
//           padding: '10px 15px',
//           borderRadius: '8px',
//           boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//           border: 'none',
//           outline: 'none'
//         }}>
//           <p style={{ margin: 0, fontWeight: 600, color: payload[0].payload.fill }}>
//             {payload[0].name}: <span style={{ color: '#333' }}>{payload[0].value}</span>
//           </p>
//         </div>
//       );
//     }
//     return null;
//   };

//   return (
//     <div
//       className="piechart-wrapper piechart"
//       style={{
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'space-between',
//         width: '100%',
//         height: height,
//         backgroundColor: '#fff', // Ensure a clean background for the shadow to pop
//         borderRadius: '12px',
//         padding: '10px'
//       }}
//     >
//       {/* 1. Left Legend (Behaviour) */}
//       <div className="attendancechart-heading" style={{ flex: 1, minWidth: '120px' }}>
//         <div className="repo-heading-a font-weight500 font-size-subheading" style={{ marginBottom: '15px', color: '#555' }}>
//           Behaviour
//         </div>
//         <div>
//           {data.map((item) => (
//             <div key={item.name} className="piechart-legend" style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
//               <div
//                 className="piechart-dot"
//                 style={{ backgroundColor: item.fill, width: '12px', height: '12px', borderRadius: '50%', marginRight: '10px', boxShadow: `0 0 5px ${item.fill}80` }}
//               ></div>
//               <div className="piechart-subheading font-weight500 font-size-subheading" style={{ color: '#444' }}>
//                 {item.name} <span style={{ fontWeight: 700, marginLeft: '4px' }}>{item.uv}</span>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* 2. Center Chart */}
//       <div style={{ flex: 2, height: '100%', minWidth: '220px', position: 'relative' }}>
//         <ResponsiveContainer width="100%" height="100%">
//           <PieChart>
//             {/* Defining a subtle drop shadow for the chart */}
//             <defs>
//               <filter id="shadow" x="-20%" y="-20%" width="140%" height="140%">
//                 <feDropShadow dx="0" dy="4" stdDeviation="6" floodOpacity="0.15" />
//               </filter>
//             </defs>

//             <Tooltip content={<CustomTooltip />} />

//             <Pie
//               data={data}
//               dataKey="uv"
//               innerRadius="55%"
//               outerRadius="80%"
//               stroke="none"
//               paddingAngle={5}     // Fancy: Adds spacing between slices
//               cornerRadius={8}     // Fancy: Rounds the edges of the slices
//               style={{ filter: 'url(#shadow)' }} // Applies the drop shadow defined above
//             >
//               {data.map((entry, index) => (
//                 <Cell 
//                   key={`cell-${index}`} 
//                   fill={entry.fill} 
//                   style={{ outline: 'none' }} // Prevents blue outline on click
//                 />
//               ))}
//             </Pie>
//           </PieChart>
//         </ResponsiveContainer>

//         {/* Optional: Center Text Overlay */}
//         <div style={{
//           position: 'absolute',
//           top: '50%',
//           left: '50%',
//           transform: 'translate(-50%, -50%)',
//           textAlign: 'center',
//           pointerEvents: 'none' // Ensures tooltip still works when hovering center
//         }}>
//           <div style={{ fontSize: '12px', color: '#888' }}>Total</div>
//           <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#333' }}>
//              {data.reduce((acc, curr) => acc + curr.uv, 0)}
//           </div>
//         </div>
//       </div>

//       {/* 3. Right Legend (Attendance) */}
//       <div className="attendancechart-heading" style={{ flex: 1, minWidth: '120px' }}>
//         <div className="repo-heading-a font-weight500 font-size-subheading" style={{ marginBottom: '15px', color: '#555' }}>
//           Attendance
//         </div>
//         <div>
//           {display.map((item) => (
//             <div key={item.name} className="piechart-legend" style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
//               <div
//                 className="piechart-dot"
//                 style={{ backgroundColor: item.fill, width: '12px', height: '12px', borderRadius: '50%', marginRight: '10px', boxShadow: `0 0 5px ${item.fill}80` }}
//               ></div>
//               <div className="piechart-subheading font-weight500 font-size-subheading" style={{ color: '#444' }}>
//                 {item.name} <span style={{ fontWeight: 700, marginLeft: '4px' }}>{item.uv}</span>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AttendanceChart;



// import React from 'react';
// import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';

// const AttendanceChart = ({ allattendanceStatus, height }) => {
//   // Combining both datasets into a format perfect for a stacked bar chart
//   const combinedData = [
//     {
//       name: "Behaviour",
//       "On Time": allattendanceStatus.ontime,
//       "Late": allattendanceStatus.late,
//       "Half Day": allattendanceStatus.halfday,
//       "Absent": allattendanceStatus.absent,
//     },
//     {
//       name: "Attendance",
//       "Present": allattendanceStatus.present,
//       "Out Duty": allattendanceStatus.outduty,
//       "Leave": allattendanceStatus.leave,
//       "Absent ": allattendanceStatus.absent, // Space added to differentiate from Behaviour's Absent key
//     }
//   ];

//   const CustomTooltip = ({ active, payload, label }) => {
//     if (active && payload && payload.length) {
//       return (
//         <div style={{ backgroundColor: '#fff', padding: '10px 15px', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)'}}>
//           <p style={{ margin: '0 0 8px 0', fontWeight: 'bold', borderBottom: '1px solid #eee', paddingBottom: '4px' }}>{label}</p>
//           {payload.map((entry, index) => (
//             // Only show values greater than 0 in the tooltip to keep it clean
//             entry.value > 0 && (
//               <div key={index} style={{ display: 'flex', justifyContent: 'space-between', gap: '15px', marginBottom: '4px' }}>
//                 <span style={{ color: entry.fill, fontWeight: 500 }}>{entry.name}:</span>
//                 <span style={{ fontWeight: 'bold', color: '#333' }}>{entry.value}</span>
//               </div>
//             )
//           ))}
//         </div>
//       );
//     }
//     return null;
//   };

//   return (
//     <div
//       className="piechart-wrapper"
//       style={{
//         display: 'flex',
//         flexDirection: 'column',
//         width: '100%',
//         height: height,
//         backgroundColor: '#fff',
//         borderRadius: '12px',
//         padding: '20px',
//         boxSizing: 'border-box'
//       }}
//     >
//       <div className="repo-heading-a font-weight500 font-size-subheading" style={{ marginBottom: '20px', color: '#444' }}>
//         Attendance & Behaviour Overview
//       </div>

//       <div style={{ flex: 1, width: '100%', minHeight: '150px' }}>
//         <ResponsiveContainer width="100%" height="100%">
//           <BarChart
//             layout="vertical"
//             data={combinedData}
//             margin={{ top: 0, right: 20, left: 10, bottom: 0 }}
//             barSize={35} // Thick, modern bars
//           >
//             <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#f0f0f0" />
//             <XAxis type="number" hide /> 
//             <YAxis 
//               dataKey="name" 
//               type="category" 
//               axisLine={false} 
//               tickLine={false} 
//               tick={{ fill: '#555', fontWeight: 600, fontSize: 14 }}
//               width={90}
//             />
//             <Tooltip cursor={{ fill: '#f9f9f9' }} content={<CustomTooltip />} />

//             {/* Behaviour Stack */}
//             <Bar dataKey="On Time" stackId="a" fill="#18A118" radius={[4, 0, 0, 4]} />
//             <Bar dataKey="Late" stackId="a" fill="#F7BA1E" />
//             <Bar dataKey="Half Day" stackId="a" fill="#FF747C" />
//             <Bar dataKey="Absent" stackId="a" fill="#FF0000" radius={[0, 4, 4, 0]} />

//             {/* Attendance Stack (Uses stackId 'b' so it stays on its own row) */}
//             <Bar dataKey="Present" stackId="b" fill="#18A118" radius={[4, 0, 0, 4]} />
//             <Bar dataKey="Out Duty" stackId="b" fill="#2576BC" />
//             <Bar dataKey="Leave" stackId="b" fill="#30C9C9" />
//             <Bar dataKey="Absent " stackId="b" fill="#FF0000" radius={[0, 4, 4, 0]} />
//           </BarChart>
//         </ResponsiveContainer>
//       </div>
//     </div>
//   );
// };

// export default AttendanceChart;




import React from 'react';

const AttendanceChart = ({ allattendanceStatus }) => {
  // 1. Prepare Data with Modern Color Palettes
  const behaviourData = [
    { name: "On Time", value: allattendanceStatus.ontime, color: "#10B981", bg: "#D1FAE5" },
    { name: "Late", value: allattendanceStatus.late, color: "#F59E0B", bg: "#FEF3C7" },
    { name: "Half Day", value: allattendanceStatus.halfday, color: "#F43F5E", bg: "#FFE4E6" },
    { name: "Absent", value: allattendanceStatus.absent, color: "#EF4444", bg: "#FEE2E2" },
  ];

  const attendanceData = [
    { name: "Present", value: allattendanceStatus.present, color: "#10B981", icon: "✔️" },
    { name: "Out Duty", value: allattendanceStatus.outduty, color: "#3B82F6", icon: "🏢" },
    { name: "Leave", value: allattendanceStatus.leave, color: "#06B6D4", icon: "🌴" },
    { name: "Absent", value: allattendanceStatus.absent, color: "#EF4444", icon: "❌" },
  ];

  // Find the max value to scale the progress bars proportionally
  const maxBehaviour = Math.max(...behaviourData.map(d => d.value), 1);

  return (
    <div className="attendance-chart">

      {/* LEFT SIDE: Linear Progress Bars for Behaviour */}
      <div style={{ flex: 1 }}>
        <h3 style={{ margin: '0 0 20px 0', fontSize: '16px', color: '#4B5563', fontWeight: 600 }}>
          Behaviour Overview
        </h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {behaviourData.map((item) => {
            const widthPercent = `${(item.value / maxBehaviour) * 100}%`;

            return (
              <div key={item.name}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '6px', fontSize: '14px' }}>
                  <span style={{ fontWeight: 500, color: '#374151' }}>{item.name}</span>
                  <span style={{ fontWeight: 700, color: item.color }}>{item.value} days</span>
                </div>
                {/* Custom Progress Bar */}
                <div style={{ height: '8px', width: '100%', backgroundColor: '#F3F4F6', borderRadius: '999px', overflow: 'hidden' }}>
                  <div style={{
                    height: '100%',
                    width: widthPercent,
                    backgroundColor: item.color,
                    borderRadius: '999px',
                    transition: 'width 1s ease-in-out' // Smooth load animation
                  }} />
                </div>
              </div>
            )
          })}
        </div>
      </div>

      {/* DIVIDER */}
      <div style={{ width: '1px', backgroundColor: '#E5E7EB' }}></div>

      {/* RIGHT SIDE: Stat Cards for Attendance */}
      <div style={{ flex: 1 }}>
        <h3 style={{ margin: '0 0 20px 0', fontSize: '16px', color: '#4B5563', fontWeight: 600 }}>
          Attendance Log
        </h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
          {attendanceData.map((item) => (
            <div key={item.name} style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              padding: '16px',
              backgroundColor: '#F9FAFB',
              border: '1px solid #E5E7EB',
              borderRadius: '12px',
              position: 'relative',
              overflow: 'hidden'
            }}>
              {/* Subtle colored accent line on the left of each card */}
              <div style={{ position: 'absolute', left: 0, top: 0, bottom: 0, width: '4px', backgroundColor: item.color }} />

              <span style={{ fontSize: '18px', marginBottom: '8px' }}>{item.icon}</span>
              <span style={{ fontSize: '24px', fontWeight: 800, color: '#111827', lineHeight: 1 }}>
                {item.value}
              </span>
              <span style={{ fontSize: '13px', color: '#6B7280', fontWeight: 500, marginTop: '4px' }}>
                {item.name}
              </span>
            </div>
          ))}
        </div>
      </div>

    </div>
  );
};

export default AttendanceChart;